import React from 'react';
import SpinStyle from './styles';

const Spin = props => (
  <SpinStyle viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
  <circle className="spinCircle" cx="50" cy="50" r="45"/>
  </SpinStyle>
);

export default Spin;
